// src/pages/About.jsx
import React from "react";
import MainLayout from "../components/Layouts/MainLayout";
import InnerBanner from "../components/PagesComponents/InnerBanner";
import AboutUs from "../components/PagesComponents/AboutUs";

const About = () => {
  return (
    <MainLayout>
      <InnerBanner pageKey="about" />
      <AboutUs />
    </MainLayout>
  );
};

export default About;